import moment from "moment";
import { Cell } from "../Cell";
import { ApplicantOrInvitee } from "../../types";

interface ApplicationStartedCellProps {
  applicant: ApplicantOrInvitee;
}

export const ApplicationStartedCell = ({
  applicant
}: ApplicationStartedCellProps) => {
  const isApplicant = "verifications" in applicant;

  return (
    <Cell isFirst isDataCell className="text-content-400">
      {isApplicant && applicant.application_started_at
        ? moment(applicant.application_started_at).format(
            "MMM DD, YYYY [at] h:mm A"
          )
        : "-"}
    </Cell>
  );
};
